import { useContext } from "react";
import { Dropdown, Menu, MenuButton, MenuItem, ListItemDecorator, Typography } from "@mui/joy";
import SwapHorizRoundedIcon from '@mui/icons-material/SwapHorizRounded';
import BadgeRoundedIcon from '@mui/icons-material/BadgeRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { LayoutContext } from "../../context";

const ROLE_LABELS = {
    manager: 'Менеджер',
    head_manager: 'Руководитель',
    quality_master: 'Контроль качества',
    surveyor: 'Обмерщик',
    draftsman: 'Чертежник',
};

export default function SwitchRoleButton() {
    const { availableCabinets, effectiveRole, switchRole } = useContext(LayoutContext);

    const positions = availableCabinets || [];
    if (positions.length < 2) return null;

    return (
        <Dropdown>
            <MenuButton
                slots={{ root: 'button' }}
                slotProps={{
                    root: {
                        style: {
                            border: 'none',
                            background: 'var(--joy-palette-primary-softBg)',
                            color: 'var(--joy-palette-primary-plainColor)',
                            borderRadius: 'var(--joy-radius-lg)',
                            width: 32,
                            height: 32,
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }
                    }
                }}
                title="Сменить кабинет"
            >
                <SwapHorizRoundedIcon fontSize="lg" />
            </MenuButton>

            <Menu placement="top-end" sx={{ borderRadius: 15, gap: 0.5, minWidth: 220, p: 0.5, zIndex: 100000 }}>
                <Typography level="body-xs" sx={{ px: 1.5, py: 1, color: 'text.tertiary' }}>
                    Сменить кабинет
                </Typography>
                {positions.map((role) => {
                    const isActive = role === effectiveRole;
                    return (
                        <MenuItem
                            key={role}
                            selected={isActive}
                            disabled={isActive}
                            onClick={() => switchRole(role)}
                        >
                            <ListItemDecorator>
                                {isActive ? <CheckRoundedIcon fontSize="small" /> : <BadgeRoundedIcon fontSize="small" />}
                            </ListItemDecorator>
                            {ROLE_LABELS[role] || role}
                        </MenuItem>
                    );
                })}
            </Menu>
        </Dropdown>
    );
}